import { useRef } from "react";
import { ArrowButton } from "../../../../../../components/features/ArrowButton";
import { ProfilerProduct } from "../../../../types/ProfilerProduct";
import { OtherProductCard } from "../../OtherProductCard";

type BeautyProfilerBeautyRitualProps = {
  topOtherProduct: {
    topGlamliner: ProfilerProduct | null;
    topOtherProducts: ProfilerProduct[];
  };
};

export const BeautyProfilerBeautyRitual = ({
  topOtherProduct,
}: BeautyProfilerBeautyRitualProps) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div className="flex flex-col">
        <p className="text-[#CE0A2C] text-center font-garamond-italic text-[24px] italic font-normal">
          Your personalized Christian Louboutin
        </p>
        <h1 className="text-[#050505] text-center font-bebas-kai text-[40px] font-normal">
          Beauty Ritual
        </h1>
        <p className="text-[#050505] text-center font-garamond-italic text-[26px] italic font-normal">
          with...
        </p>
      </div>
      <div className="flex justify-between items-end self-stretch">
        <p className="text-[#050505] text-center font-garamond-italic text-[22px] italic font-normal">
          Your allure, your lips signature
        </p>
        <ArrowButton
          ariaLabel="Scroll products right"
          scrollContainerRef={scrollContainerRef}
        />
      </div>
      <div className="flex w-full">
        <div
          ref={scrollContainerRef}
          className="flex overflow-x-auto gap-4 w-full justify-evenly"
        >
          <OtherProductCard
            name={topOtherProduct.topGlamliner?.label}
            imagePath={`/beauty-profiler/other-products/${topOtherProduct.topGlamliner?.id}.png`}
          />
          <OtherProductCard
            name={topOtherProduct.topOtherProducts[0]?.label}
            imagePath={`/beauty-profiler/other-products/${topOtherProduct.topOtherProducts[0]?.id}.png`}
          />
          <OtherProductCard
            name={topOtherProduct.topOtherProducts[1]?.label}
            imagePath={`/beauty-profiler/other-products/${topOtherProduct.topOtherProducts[1]?.id}.png`}
          />
        </div>
      </div>
    </>
  );
};
